/*
 * Copyright © 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {IComponentOptions} from 'angular';
require('./dv-alert-box.scss');
let alertTemplate = require('./dv-alert-box.html');

export class DvAlertBoxComponentConfig implements IComponentOptions {
    transclude = true;
    bindings: any = {
        alertType: '@',
        size: '@?',
    };
    template = alertTemplate;
    controller = DvAlertBoxController;
    controllerAs = 'vm';
}

export class DvAlertBoxController {
    alertType: string;
    alertTypeClass: string;
    size: string;
    sizeClass: string;

    $onInit() {
        this.sizeClass = 'dv-alert-box--' + (this.size ? this.size : 'normal');
        this.alertTypeClass = 'dv-alert-box--' + (this.alertType ? this.alertType : 'info');
    }
}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-alert-box/dv-alert-box.ts